import { EdiStopProgress } from "../EdiStopProgress";
import { Button, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiOrderOverview extends Layout {
    buttonMoveDetails: Button;
    horizontalspacer10: HorizontalSpacer;
    horizontalspacer11: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacer9: HorizontalSpacer;
    imageCommitment: Image;
    imageInboundTenderError: Image;
    imageInboundWarning: Image;
    imageOutboundTenderError: Image;
    imageReplyError: Image;
    imageXRef: Image;
    labelAction: Label;
    labelAppType: Label;
    labelAppTypeCaption: Label;
    labelBOL: Label;
    labelBatchID: Label;
    labelBillDistanceInbound: Label;
    labelBillDistanceOutbound: Label;
    labelBillOfLading: Label;
    labelBillingDistanceInbound: Label;
    labelCarrierPay: Label;
    labelConsRefno: Label;
    labelConsigneeReferenceNumber: Label;
    labelCreateDate: Label;
    labelCreateDateCaption: Label;
    labelCreateDtCaption: Label;
    labelDirection: Label;
    labelDirectionCaption: Label;
    labelEquipmentTypeId: Label;
    labelFreightCharge: Label;
    labelFreightCharges: Label;
    labelGSDateCaption: Label;
    labelGsDateTime: Label;
    labelMoveStatus: Label;
    labelMustRespondBy: Label;
    labelOrderValueCaption: Label;
    labelOtherCharges: Label;
    labelOtherchargetotal: Label;
    labelOverridePayAmt: Label;
    labelOverview: Label;
    labelPartnerName: Label;
    labelPartnerNameID: Label;
    labelPayAdjustments: Label;
    labelPayAdjustmentsTotal: Label;
    labelPurposeCaption: Label;
    labelPurposeTypeDescr: Label;
    labelRatingUnits: Label;
    labelRbdTimezoneId: Label;
    labelReferenceNumbers: Label;
    labelReply: Label;
    labelReplyAction: Label;
    labelReplyBatchId: Label;
    labelReplyDate: Label;
    labelRespondByDate: Label;
    labelSID: Label;
    labelShipmentId: Label;
    labelTempDelim: Label;
    labelTempMax: Label;
    labelTempMin: Label;
    labelTemperatureRange: Label;
    labelTenderID: Label;
    labelTenderId: Label;
    labelTotalCharge: Label;
    labelTotalCharges: Label;
    labelTotalPay: Label;
    labelTotalPayCaption: Label;
    labelTrackingRequired: Label;
    labelTrailerType: Label;
    labelTransmitStatus: Label;
    labelTransmitted: Label;
    labelWeightCaption: Label;
    layoutStopProgress: EdiStopProgress;
    moveLabel: Label;
    panel15: Panel;
    panel6: Panel;
    panelCarrierPay: Panel;
    panelCommodity: Panel;
    panelErrorIcons: Panel;
    panelInboundCharges: Panel;
    panelLeft: Panel;
    panelOrderInfo: Panel;
    panelOrderValue: Panel;
    panelOverviewOuter: Panel;
    panelPartnerInfo: Panel;
    panelRefNbrs: Panel;
    panelReply: Panel;
    panelReplyInfo: Panel;
    panelReplyTransmit: Panel;
    panelRight: Panel;
    panelStopInfo: Panel;
    panelTempRange: Panel;
    panelWeight: Panel;
    pannelOverviewInner: Panel;
    sourceCarrierPayee: DataSource;
    sourceCarriersForAssignment: DataSource;
    sourceCustomer: DataSource;
    sourceViewEdiOrder: DataSource;
    textboxCarrierName: Textbox;
    textboxCommodity: Textbox;
    textboxName: Textbox;
    textboxOrderValue: Textbox;
    textboxWeight: Textbox;
}
